/** Company logo served from public/images/logo/ */
export const COMPANY_LOGO_SRC = '/images/logo/jet-shipping-cargo-logo.png';

export const WHATSAPP_NUMBER_E164 = '601121190765';
export const WHATSAPP_DISPLAY = '+60 11-2119 0765';

export function buildWhatsAppUrl(message) {
  const base = `https://wa.me/${WHATSAPP_NUMBER_E164}`;
  if (!message) return base;
  return `${base}?text=${encodeURIComponent(message)}`;
}

export function defaultWhatsAppQuoteMessage(pathname = '/') {
  const lines = [
    'Hello Jet Shipping Cargo,',
    'I would like a shipping quote / assistance.',
  ];
  if (pathname.startsWith('/tracking')) {
    lines.push('I am checking on a shipment via your tracking page.');
  } else if (pathname.startsWith('/contact')) {
    lines.push('I have a question before submitting the contact form.');
  } else if (pathname.startsWith('/services')) {
    lines.push('I am interested in your logistics services.');
  }
  lines.push('Thank you.');
  return lines.join('\n');
}

